import { Injectable } from '@angular/core';

export interface State {

  abbreviation: string;
  name: string;
}

const states = [

  {
    abbreviation: 'AC',
    name: 'Acre'
  },
  {
    abbreviation: 'AL',
    name: 'Alagoas'
  },
  {
    abbreviation: 'AP',
    name: 'Amapá'
  },
  {
    abbreviation: 'AM',
    name: 'Amazonas'
  },
  {
    abbreviation: 'BA',
    name: 'Bahia'
  },
  {
    abbreviation: 'CE',
    name: 'Ceará'
  },
  {
    abbreviation: 'DF',
    name: 'Distrito Federal'
  },
  {
    abbreviation: 'ES',
    name: 'Espírito Santo'
  },
  {
    abbreviation: 'GO',
    name: 'Goiás'
  },
  {
    abbreviation: 'MA',
    name: 'Maranhão'
  },
  {
    abbreviation: 'MT',
    name: 'Mato Grosso'
  },
  {
    abbreviation: 'MS',
    name: 'Mato Grosso do Sul'
  },
  {
    abbreviation: 'MG',
    name: 'Minas Gerais'
  },
  {
    abbreviation: 'PA',
    name: 'Pará'
  },
  {
    abbreviation: 'PB',
    name: 'Paraíba'
  },
  {
    abbreviation: 'PR',
    name: 'Paraná'
  },
  {
    abbreviation: 'PE',
    name: 'Pernambuco'
  },
  {
    abbreviation: 'PI',
    name: 'Piauí'
  },
  {
    abbreviation: 'RJ',
    name: 'Rio de Janeiro'
  },
  {
    abbreviation: 'RN',
    name: 'Rio Grande do Norte'
  },
  {
    abbreviation: 'RS',
    name: 'Rio Grande do Sul'
  },
  {
    abbreviation: 'RO',
    name: 'Rondônia'
  },
  {
    abbreviation: 'RR',
    name: 'Romaima'
  },
  {
    abbreviation: 'SC',
    name: 'Santa Catarina'
  },
  {
    abbreviation: 'SP',
    name: 'São Paulo'
  },
  {
    abbreviation: 'SE',
    name: 'Sergipe'
  },
  {
    abbreviation: 'TO',
    name: 'Tocantins'
  }
];

const statesEmptyOption = [

  {
    abbreviation: '',
    name: ''
  },
  {
    abbreviation: 'AC',
    name: 'Acre'
  },
  {
    abbreviation: 'AL',
    name: 'Alagoas'
  },
  {
    abbreviation: 'AP',
    name: 'Amapá'
  },
  {
    abbreviation: 'AM',
    name: 'Amazonas'
  },
  {
    abbreviation: 'BA',
    name: 'Bahia'
  },
  {
    abbreviation: 'CE',
    name: 'Ceará'
  },
  {
    abbreviation: 'DF',
    name: 'Distrito Federal'
  },
  {
    abbreviation: 'ES',
    name: 'Espírito Santo'
  },
  {
    abbreviation: 'GO',
    name: 'Goiás'
  },
  {
    abbreviation: 'MA',
    name: 'Maranhão'
  },
  {
    abbreviation: 'MT',
    name: 'Mato Grosso'
  },
  {
    abbreviation: 'MS',
    name: 'Mato Grosso do Sul'
  },
  {
    abbreviation: 'MG',
    name: 'Minas Gerais'
  },
  {
    abbreviation: 'PA',
    name: 'Pará'
  },
  {
    abbreviation: 'PB',
    name: 'Paraíba'
  },
  {
    abbreviation: 'PR',
    name: 'Paraná'
  },
  {
    abbreviation: 'PE',
    name: 'Pernambuco'
  },
  {
    abbreviation: 'PI',
    name: 'Piauí'
  },
  {
    abbreviation: 'RJ',
    name: 'Rio de Janeiro'
  },
  {
    abbreviation: 'RN',
    name: 'Rio Grande do Norte'
  },
  {
    abbreviation: 'RS',
    name: 'Rio Grande do Sul'
  },
  {
    abbreviation: 'RO',
    name: 'Rondônia'
  },
  {
    abbreviation: 'RR',
    name: 'Romaima'
  },
  {
    abbreviation: 'SC',
    name: 'Santa Catarina'
  },
  {
    abbreviation: 'SP',
    name: 'São Paulo'
  },
  {
    abbreviation: 'SE',
    name: 'Sergipe'
  },
  {
    abbreviation: 'TO',
    name: 'Tocantins'
  }
];

@Injectable()
export class States {

  getStates() {

    return states;
  }

  getStatesEmptyOption() {

    return statesEmptyOption;
  }
}
